export const ALBAIK_CUSTOMER_CARE_NUMBER = "800 244 2245";
export const KSA_PHONE_PREFIX = "+966";
export const KSA_PREFIX_NUMBER = "00966";
export const UAE_PHONE_PREFIX = "+971";
export const UAE_PREFIX_NUMBER = "00971";
